import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.4 0H1C0.4 0 0 0.4 0 1V9.3C0 9.9 0.4 10.3 1 10.3H21.4C22 10.3 22.4 9.9 22.4 9.3V1C22.4 0.4 21.9 0 21.4 0ZM20.4 8.3H2V2H20.4V8.3ZM9.3 12H1C0.4 12 0 12.4 0 13V21.3C0 21.9 0.4 22.3 1 22.3H9.3C9.9 22.3 10.3 21.9 10.3 21.3V13C10.3 12.5 9.9 12 9.3 12ZM8.3 20.4H2V14H8.3V20.4ZM21.4 12H13C12.4 12 12 12.4 12 13V21.3C12 21.9 12.4 22.3 13 22.3H21.3C21.9 22.3 22.3 21.9 22.3 21.3V13C22.4 12.5 21.9 12 21.4 12ZM20.4 20.4H14V14H20.3V20.4H20.4Z",
		fill: "white"
	})
});
export default SvgDashboard;
